import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './globals.css'
import { env } from './lib/env'

// Surface the pipeline build id in the document head. References env.buildId so it
// is baked into the entry bundle, changing file hashes per build to bust stale caches.
const buildMeta = document.createElement('meta')
buildMeta.name = 'build-id'
buildMeta.content = env.buildId
document.head.appendChild(buildMeta)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)